import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';

import { history, HistoryHelper } from '../_helpers';
import { ColorHelper } from '../_helpers/ColorHelper';
import { PrivateRoute } from './PrivateRoute';

import { WEBAPP_URLS, URL_CONSTANTS } from '../_constants';
import { LoginPage } from '../LoginModule/LoginPage';
import { RegisterPage } from '../LoginModule/RegisterPage';
import { WrappedApp } from '../App/WrappedApp';
import { Selectors } from '../_reducers/app.reducer';
import { EntrypointActions } from "../../Common/_stores/EntrypointStore/EntrypointActions";
import { SUBDOMAIN_IDS } from '../../SUBDOMAIN_IDS';
import { PMSOctorateRedirectPopup } from '../../PMS/ModuleIntegrations/_components/PMSOctorateRedirectPopup';
import { getActiveBrand } from '../../Common/branding/activeBrand';
import { i18n } from '../_translations/i18n';

export function Routes() {

    //LIBRARIES
    const dispatch = useDispatch();

    //GLOBAL STATE
    const host = useSelector(Selectors.getEntrypointHost);
    
    //LOCAL STATE
    const [isInitialized, setIsInitialized] = useState(false);

    //INITIALIZATION
    useEffect(() => {
        const brand = getActiveBrand();
        ColorHelper.applyBrandColors(brand);
        document.title = `${brand.name} ${i18n.t("webapp_global_control_panel")}`;
    }, []);

    useEffect(() => {
        const subdomain = HistoryHelper.getSubdomain();
        if (!subdomain) {
            setIsInitialized(true);
            return;
        }
        dispatch(EntrypointActions.getEntrypointHost(subdomain));
    }, [dispatch]);

    //EFFECTS
    useEffect(() => {
        if (host) {
            setIsInitialized(true);
            const brand = getActiveBrand();
            switch (host) {
                case SUBDOMAIN_IDS.BUDGETS:
                    document.title = `${brand.name} Budgets`;
                    break;

                case SUBDOMAIN_IDS.DEVELOPERS:
                    document.title = `${brand.name} Developers Console`;
                    break;

                case SUBDOMAIN_IDS.PMS:
                case SUBDOMAIN_IDS.RENTAL:
                    document.title = `${brand.name} Rental App`;
                    break;

                default:
                    document.title = `${brand.name} ${i18n.t("webapp_global_control_panel")}`;
            }
        }

    }, [host]);

    if (!isInitialized) {
        return null;
    }

    return (
        <Router history={history}>
            <Switch>
                <Route 
                    path={WEBAPP_URLS.PRIVACY_POLICY} 
                    component={() => { 
                        window.location.href = URL_CONSTANTS.PRIVACY_POLICY;
                        return null;
                    }}
                />
                <Route 
                    path={WEBAPP_URLS.TERMS} 
                    component={() => { 
                        window.location.href = URL_CONSTANTS.TERMS_OF_USE;
                        return null;
                    }}
                />
                <Route
                    exact
                    path={WEBAPP_URLS.LOGIN}
                    component={LoginPage}
                />
                <Route
                    exact
                    path={WEBAPP_URLS.REGISTER}
                    component={RegisterPage}
                />
                <Route
                    exact
                    path={WEBAPP_URLS.OAUTH}
                    render={(props) => (
                        <LoginPage {...props} 
                            isOauth = {true}
                        />
                    )}
                />
                <Route
                    path={WEBAPP_URLS.OAUTH_OCTORATE}
                    render={(props) => (
                        <PMSOctorateRedirectPopup 
                            props={props}
                        />
                    )}
                />
                <PrivateRoute
                    host={host}
                    path={WEBAPP_URLS.ROOT}
                    component={WrappedApp}
                />
            </Switch>
        </Router>
    );
}